export enum CheckboxSize {
  Default = 'default',
  Small = 'small',
  Large = 'large'
}
